import { render } from "./EmailPreview.vue?vue&type=template&id=0fe88792&scoped=true"
import script from "./EmailPreview.vue?vue&type=script&lang=js"
export * from "./EmailPreview.vue?vue&type=script&lang=js"

import "./EmailPreview.vue?vue&type=style&index=0&id=0fe88792&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe88792"]])

export default __exports__